import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUser } from '@/lib/auth';
import { PageShell, Stack } from '@/ui/layout';
import { AvatarSection } from '@/modules/perfil/components/AvatarSection';
import { DadosPessoaisForm } from '@/modules/perfil/components/DadosPessoaisForm';
import { SenhaForm } from '@/modules/perfil/components/SenhaForm';
import { SessoesAtivas } from '@/modules/perfil/components/SessoesAtivas';
import { PreferenciasNotificacao } from '@/modules/perfil/components/PreferenciasNotificacao';

export const Route = createFileRoute('/_authed/perfil')({
  component: PerfilPage,
});

function PerfilPage() {
  const { data: user, isLoading } = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: ({ signal }) => fetchCurrentUser(signal),
  });

  if (isLoading || !user) {
    return (
      <PageShell eyebrow="Admin" title="Meu Perfil">
        <p className="text-sm text-text-muted">Carregando…</p>
      </PageShell>
    );
  }

  return (
    <PageShell
      eyebrow="Admin"
      title="Meu Perfil"
      lead="Gerencie suas informações, segurança e preferências."
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 max-w-5xl">
        <Stack gap="md">
          <AvatarSection user={user} />
          <DadosPessoaisForm user={user} />
        </Stack>
        <Stack gap="md">
          <SenhaForm userId={user.id} />
          <SessoesAtivas userId={user.id} />
          <PreferenciasNotificacao user={user} />
        </Stack>
      </div>
    </PageShell>
  );
}
